import type {
  GroupedData,
  GroupedDataPoint,
  MultiVariateTransformData,
  RawData,
} from "../interface/interface";

function multivariantGroupByTime(data: RawData): MultiVariateTransformData {
  const allTimes = new Set<string>();
  const keys = Object.keys(data);

  for (const key of keys) {
    data[key].forEach((entry) => allTimes.add(entry._time));
  }

  const sortedTimes = Array.from(allTimes).sort(); // optional sorting

  const lookupMaps: Record<string, Map<string, number>> = {};
  for (const key of keys) {
    lookupMaps[key] = new Map(
      data[key].map((entry) => [entry._time, entry._value]),
    );
  }

  const grouped: GroupedData = sortedTimes.map((time) => {
    const row: GroupedDataPoint = { _time: time };
    for (const key of keys) {
      row[key] = lookupMaps[key].get(time) ?? 0;
    }
    return row;
  });

  return {
    sortedMetricsData: grouped,
    metrics: keys,
  };
}

export { multivariantGroupByTime };
